// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__ofNGa","left":"InfoRow_left___KaV3"};